const rootActionPath = 'core/ShopWifiHiw';

export const WATCH_HOW_IT_WORKS_VIEW = `${rootActionPath}/VIEW`;
